export class ContextualTransformer {
    context;
    constructor(context) {
        this.context = context;
    }
    /**
     * Трансформирует фильтры настроек для браузера.
     *
     * Не мутирует настройку.
     * Возвращает новую настройку, если были изменения.
     *
     * @param {ISetting} setting - настройка
     * @returns {ISetting}
     * @memberof SettingTransformer
     */
    transform(setting) {
        let filter = setting.filter;
        if (filter.unique_by_request) {
            if (this.context.instanceId) {
                filter = { ...filter, 'instance-id': this.context.instanceId };
            }
            else {
                filter = { ...filter, 'request-id': this.context.requestId };
            }
        }
        if (filter === setting.filter) {
            return setting;
        }
        return {
            ...setting,
            filter,
        };
    }
}
//# sourceMappingURL=ContextualTransformer.js.map